// Randomize presentation once per tab session; product eligibility is server-rendered.
(() => {
  if (customElements.get('session-bestseller')) return;
  const sessionKey = 'ev:bestseller-label:v1';
  customElements.define('session-bestseller', class extends HTMLElement {
    connectedCallback() {
      try {
        let decision = sessionStorage.getItem(sessionKey);
        if (decision !== 'show' && decision !== 'hide') {
          decision = Math.random() < 0.5 ? 'show' : 'hide';
          sessionStorage.setItem(sessionKey, decision);
        }
        this.hidden = decision !== 'show';
      } catch {
        // Keep the optional label hidden when stable session assignment is unavailable.
        this.hidden = true;
      }
    }
  });
})();
